// to resolve issues with overwritten resize handlers, register components into an array
// registered components will be told to perform resize calculations whenever the window resizes

import { limit } from "../helpers/utils";
import Vue from "vue";

const components = [];

function resetViews() { 
  Vue.nextTick().then(() => components.forEach(c => c.resetView && c.resetView(c._uid)));
}

const limitResetViews = limit(resetViews, 25);

window.addEventListener("resize", limitResetViews);

export function registerResize(component) {
  if (!components.includes(component)) components.push(component);
}

export function clearResize(component) {
  let index = components.indexOf(component);
  if (index >= 0) components.splice(index, 1);
}